import { Text, makeStyles, tokens } from "@fluentui/react-components";
import type { ReactNode } from "react";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: tokens.spacingVerticalXXL,
    gap: tokens.spacingVerticalM,
    color: tokens.colorNeutralForeground3,
    textAlign: "center",
  },
});

export interface EmptyStateProps {
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
}

export const EmptyState = ({ title, description, actions }: EmptyStateProps): React.JSX.Element => {
  const styles = useStyles();
  return (
    <div className={styles.root}>
      <Text size={400} weight="semibold">{title}</Text>
      {description ? <Text size={300}>{description}</Text> : null}
      {actions}
    </div>
  );
};
